import { WidgetNames } from "constants/widgets";
import { WidgetTypes } from "types/Widget";

import { BlankWidget } from "./BlankWidget";
import { BoogleWidget } from "./Boogle";
import { InteractiveCalendarWidget } from "./Calendar";
import { CartesianPlaneWidget } from "./CartesianPlane";
import { InteractiveDiceWidget } from "./DiceRoller";
import { FreeDrawingWidget } from "./FreeDrawing";
import { FreeHandWritingWidget } from "./Free HandWriting";
import { FreeTextWidget } from "./FreeText";
import { GoogleSlidesWidget } from "./GoogleSlides";
import { InteractiveGroupMakerWidget } from "./GroupMaker";
import { InteractiveHundredsChart } from "./HundredsChart";
import { ImageWidget } from "./Image";
import { InteractiveClockWidget } from "./InteractiveClock";
import { LearningIntentionWidget } from "./LearningIntentions";
import { MABWidget } from "./MAB";
import { MoneyWidget } from "./Money";
import { NoggleWidget } from "./Noggle";
import { InteractiveNoiseMeterWidget } from "./NoiseMeter";
import { NumberLineWidget } from "./NumberLine";
import { PlaceValueMatWidget } from "./PlaceValueMat";
import { InteractiveRandomNameWidget } from "./RandomName";
import { SchedulerWidget } from "./Scheduler";
import { InteractiveSpinnerWidget } from "./Spinner";
import { StopwatchWidget } from "./Stopwatch";
import { InteractiveTimerWidget } from "./Timer";
import { WellbeingCheckWidget } from "./WellbeingCheck";
import { WordBuilderkWidget } from "./WordBuilder";
import { YoutubeWidget } from "./Youtube";

export const AllWidgetTypes: WidgetTypes = {
  [WidgetNames.blankWidget]: BlankWidget,
  [WidgetNames.interactiveClock]: InteractiveClockWidget,
  [WidgetNames.dice]: InteractiveDiceWidget,
  [WidgetNames.timer]: InteractiveTimerWidget,
  [WidgetNames.stopwatch]: StopwatchWidget,
  [WidgetNames.randomName]: InteractiveRandomNameWidget,
  [WidgetNames.spinner]: InteractiveSpinnerWidget,
  [WidgetNames.calendar]: InteractiveCalendarWidget,
  [WidgetNames.hundredsChart]: InteractiveHundredsChart,
  [WidgetNames.placeValueMat]: PlaceValueMatWidget,
  [WidgetNames.mab]: MABWidget,
  [WidgetNames.noiseMeter]: InteractiveNoiseMeterWidget,
  [WidgetNames.wellbeing]: WellbeingCheckWidget,
  [WidgetNames.numberLine]: NumberLineWidget,
  [WidgetNames.scheduler]: SchedulerWidget,
  [WidgetNames.wordBuilder]: WordBuilderkWidget,
  [WidgetNames.youtube]: YoutubeWidget,
  [WidgetNames.freeText]: FreeTextWidget,
  [WidgetNames.googleSlides]: GoogleSlidesWidget,
  [WidgetNames.image]: ImageWidget,
  [WidgetNames.groupMaker]: InteractiveGroupMakerWidget,
  [WidgetNames.noggle]: NoggleWidget,
  [WidgetNames.boogle]: BoogleWidget,
  [WidgetNames.cartesian]: CartesianPlaneWidget,
  [WidgetNames.freeDrawing]: FreeDrawingWidget,
  [WidgetNames.money]: MoneyWidget,
  // [WidgetNames.learningIntentionWidget]: LearningIntentionWidget,
  [WidgetNames.freeHandWritingWidget]: FreeHandWritingWidget,
};
